<div class="selector-container" (click)="open = !open">
	<div class="label-container" [class.open]="open" [class.content]="selected.length">
		@if (displayLabel) {
			<span class="main-label">{{ placeholder }}{{ displayString !== '' && type !== types.DATE ? ' : ' : '' }}</span>
		}
		<span *ngIf="type !== types.DATE" class="label-selected">{{ displayString }}
      </span>
		<span class="more-counter" matTooltipClass="filter-tooltip" [matTooltip]="tooltip()"
			  *ngIf="otherElement.length">+{{ otherElement.length }}</span>
		<app-svg-selector category="icons" type="fill" svg="caret-down" [size]="1"></app-svg-selector>
	</div>
	@if (open) {
		<div class="selector-list" [class.right]="right">
			<div *ngIf="searchable" class="search" (click)="$event.stopImmediatePropagation()">
				<app-search-input [value]="search" (valueChange)="onChange($event)"
								  [placeholder]="'filter.research' | transloco"/>
			</div>
			<div class="list-content">
				<ng-container *ngFor="let elem of list; let index = index">
					@if (type === types.MULTI && staticSearch(elem)) {
						<app-checkbox [checked]="isSelected(elem)" (click)="$event.stopPropagation()"
									  (change)="checkedChange(elem)">
							<ng-container [ngTemplateOutlet]="templateVariable || defaultIconChildTemplate"
										  [ngTemplateOutletContext]="{$implicit: elem, index}"></ng-container>
						</app-checkbox>
					}
					<mat-radio-button *ngIf="type === types.MONO && staticSearch(elem)" class="content"
									  [checked]="isSelected(elem)" (click)="$event.stopPropagation()">
						<ng-container [ngTemplateOutlet]="templateVariable || defaultIconChildTemplate"
									  [ngTemplateOutletContext]="{$implicit: elem, index}"></ng-container>
					</mat-radio-button>
					<div *ngIf="type === types.DATE" class="date-content" (click)="$event.stopPropagation()">
						<ng-container [ngTemplateOutlet]="templateVariable || defaultIconChildTemplate"
									  [ngTemplateOutletContext]="{$implicit: elem, index}"></ng-container>
					</div>
				</ng-container>
				<ng-container *ngIf="searchTrigger.observed && search === ''">
					<ng-container *ngFor="let elem of selected">
						<mat-checkbox *ngIf="type === types.MULTI && staticSearch(elem)" class="content"
									  [checked]="true" (click)="$event.stopPropagation()"
									  (change)="storageChange(elem)">
							<ng-container [ngTemplateOutlet]="templateVariable || defaultIconChildTemplate"
										  [ngTemplateOutletContext]="{$implicit: elem}"></ng-container>
						</mat-checkbox>
						<mat-radio-button *ngIf="type === types.MONO && staticSearch(elem)" class="content"
										  [checked]="true" (click)="$event.stopPropagation()">
							<ng-container [ngTemplateOutlet]="templateVariable || defaultIconChildTemplate"
										  [ngTemplateOutletContext]="{$implicit: elem}"></ng-container>
						</mat-radio-button>
					</ng-container>
				</ng-container>
				@if (selected.length > 0) {
					<div class="reset" (click)="clearSelection(); $event.stopImmediatePropagation();">
						{{ 'filter.reset' | transloco }}
					</div>
				}

			</div>
		</div>
	}


</div>

<ng-template #defaultIconChildTemplate let-elem>
	<ng-container *ngIf="type !== types.DATE">
		<span>{{ label(elem) }}</span>
	</ng-container>
	<ng-container *ngIf="type === types.DATE">
		<span class="date-label">{{ label(elem) }}</span>
		<mat-form-field appearance="outline" class="custom-date-picker no-space-under"
						(click)="$event.stopPropagation()">
			<input matInput [value]="elem.value" (dateChange)="dateChange($event, elem)" [matDatepicker]="datepicker">
			<mat-datepicker-toggle matSuffix [for]="datepicker" class="toggle-calendar">
				<span matDatepickerToggleIcon class="hover icon icon-calendar"></span>
			</mat-datepicker-toggle>
			<mat-datepicker #datepicker>
				<mat-datepicker-actions>
					<button mat-button matDatepickerCancel>{{ 'app.cancel' | transloco }}</button>
					<button mat-raised-button color="primary" matDatepickerApply>{{ 'app.apply' | transloco }}</button>
				</mat-datepicker-actions>
			</mat-datepicker>
		</mat-form-field>
	</ng-container>
</ng-template>
